import React from "react";
import { Box, Typography } from "@mui/material";
import CustomAccordion from "../components/Accordion";

// Once the backend API is ready, we should modify this
import faqJSON from "../assets/json/faq.json";

interface FaqDataType {
    id: number;
    question?: string;
    answer?: string;
}

export default function FAQ() {
    return (
        <Box sx={{ px: 15, py: 8 }}>
            <Typography variant="h2" component="h2">
                FAQs
            </Typography>
            <Box sx={{ py: 3 }}>
                {faqJSON.map((faq: FaqDataType, index: number) => (
                    <Box key={index} sx={{ pt: 3 }}>
                        <CustomAccordion question={faq.question} answer={faq.answer} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}